import React, { PureComponent } from 'react';
import styled from 'styled-components';
import plotly from './../node_modules/plotly.js/dist/plotly.js';
import createPlotlyComponent from 'react-plotly.js/factory';
import * as csDictionary from './../node_modules/plotly.js/lib/locales/de.js';
import ComponentTitle from './ComponentTitle';
import UpdatedDate from './UpdatedDate';
import { normalizeBarTooltips } from './normalizeBarTooltips';

const StyledPlotsComponent = styled.div`
  grid-column: span 12;
  display: grid;
  min-width: 0;
  min-height: 0;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 40px 10px;
  @media print {
    page-break-inside: avoid;
    margin-bottom: 30px;
    display: block;
  }
`;

const StyledPlotComponent = styled.div`
  margin-top: 20px;
  grid-column: span 12;
  @media (min-width: 1280px) {
    grid-column: span ${props => props.columns};
  }
  position: relative;
`;

const StyledPlotWrapper = styled.div`
  border-radius: 5px;
  background: white;
  padding: 10px 10px 35px 10px;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(38, 47, 51, 0.3);
  overflow: hidden;
`;

class PlotsComponent extends PureComponent {
  render() {
    const config = {
      modeBarButtonsToRemove: [
        'toImage',
        'sendDataToCloud',
        'zoomIn2d',
        'zoomOut2d',
        'autoScale2d',
        'toggleSpikelines',
        'lasso2d',
        'select2d'
      ],
      displaylogo: false,
      responsive: true,
      locale: 'de'
    };

    const { title, info } = this.props;

    return (
      <StyledPlotsComponent columns={this.props.columns}>
        <ComponentTitle title={title} info={info} />
        {this.props.data.map(plot => {
          const data = JSON.parse(plot.data);
          if (data && data.data) {
            normalizeBarTooltips(data.data);
          }
          const { id, title, info_text: info } = plot;
          const Plot = createPlotlyComponent(plotly);
          // Adding the locale. Through config it is not picked up
          plotly.register(csDictionary);
          if (data && data.layout) { // Sometimes we get null for some plots
            let layout = Object.assign({}, data.layout);
            layout.font.family = 'latoregular';
            layout.font.color = '#6D7B80';
            layout.autosize = true;
            layout.width = undefined;
            layout.height = undefined;
            layout.line = { dash: 'dot' };
            if (layout.legend) {
              if (layout.legend.font) {
                layout.legend.font.family = 'latoregular';
                layout.legend.font.color = '#42515A';
              } else {
                layout.legend = {
                  font: {
                    family: 'latoregular',
                    color: '#42515A',
                  }
                };
              }
            }
            layout.annotations &&
              layout.annotations.forEach(annotation => {
                if (!annotation) {
                  return;
                }
                if (!annotation.font) {
                  annotation.font = {
                    family: 'latoblack',
                    color: '#42515A'
                  };
                } else {
                  annotation.font.family = 'latoblack';
                  annotation.font.color = '#42515A';
                }
                annotation.y = annotation.y + 0.01;
                // HACK to move low y-axis titles (rendered as annotations) in faceted charts below labels
                if (annotation.y < 0.5) {
                  annotation.y = annotation.y - 0.05;
                }
              });
            layout.xaxis.color = '#6D7B80';
            if (layout.xaxis.title && typeof layout.xaxis.title === 'object') {
              if (layout.xaxis.title.font !== undefined) {
                layout.xaxis.title.font.family = 'latoblack';
                layout.xaxis.title.font.size = 12;

              } else {
                layout.xaxis.title.font = {
                  family: 'latoregular',
                  color: '#42515A',
                  size: 12
                };
              }
            } else if (layout.xaxis.titlefont !== undefined) {
              layout.xaxis.titlefont.family = 'latoblack';
              layout.xaxis.titlefont.color = '#42515A';
              layout.xaxis.titlefont.size = 12;
            }

            // if (layout.xaxis.title) {
            //   layout.xaxis.title.font.family = 'latoblack';
            //   layout.xaxis.title.standoff = 20;
            // }
            layout.xaxis.tickfont.family = 'latoregular';
            layout.xaxis.tickfont.color = '#6D7B80';
            layout.yaxis.color = '#6D7B80';

            if (layout.yaxis.title && typeof layout.yaxis.title === 'object') {
              layout.yaxis.title.standoff = 0;
              if (layout.xaxis.title.font !== undefined) {
                layout.yaxis.title.font.family = 'latoblack';
                layout.yaxis.title.font.color = '#42515A';
                layout.yaxis.title.font.size = 12;
              } else {
                layout.yaxis.title.font = {
                  family: 'latoblack',
                  color: '#42515A',
                  size: 12
                };
              }
            } else if (layout.yaxis.titlefont !== undefined) {
              layout.yaxis.titlefont.family = 'latoblack';
              layout.yaxis.titlefont.color = '#42515A';
              layout.yaxis.titlefont.size = 12;
            }
            layout.yaxis.ticks = '';
            layout.yaxis.tickfont.family = 'latoregular';
            layout.yaxis.tickfont.color = '#6D7B80';
            for (let i = 1; i < 11; i++) {
              if (layout[`xaxis${i}`]) {
                layout[`xaxis${i}`].color = '#6D7B80';
                layout[`xaxis${i}`].tickfont.family = 'latoregular';
                layout[`xaxis${i}`].tickfont.color = '#6D7B80';
              }
              if (layout[`yaxis${i}`]) {
                layout[`yaxis${i}`].color = '#6D7B80';
                layout[`yaxis${i}`].tickfont.family = 'latoregular';
                layout[`yaxis${i}`].tickfont.color = '#6D7B80';
              }
            }
            layout.yaxis.gridcolor = '#f0f2f2';
            layout.yaxis.zeroline = true;
            if (layout.yaxis.ticktext) {
              layout.yaxis.ticktext = layout.yaxis.ticktext.map(
                ticktext => '   ' + ticktext
              );
            }
            layout.yaxis.zerolinecolor = '#6D7B80';
            layout.margin.l = 90;

            return (
              <StyledPlotComponent key={id} columns={this.props.columns}>
                <ComponentTitle title={title} info={info} />
                <StyledPlotWrapper>
                  <Plot
                    data={data.data}
                    layout={layout}
                    config={config}
                    useResizeHandler={true}
                    style={{
                      width: '100%',
                      height: `${this.props.heightInPx
                        ? `${this.props.heightInPx}px`
                        : 'auto'
                        }`
                    }}
                  />
                  <UpdatedDate>{`letztes Update: ${this.props.lastUpdated
                    }`}</UpdatedDate>
                </StyledPlotWrapper>
              </StyledPlotComponent>
            );
          }
        })}
      </StyledPlotsComponent>
    );
  }
}

export default PlotsComponent;
